module.exports = __webpack_public_path__ + "img/9b.bb7fdcbf.jpg";